export default "__VITE_PUBLIC_ASSET__28bc3bb7__"